(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("checkoutWizard", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/checkout/checkoutWizardView.html",
            controller: ["checkoutService", "frameworkService", "$localStorage", "$state", CheckoutWizardCtrl],
            controllerAs: "vm"
        };
        function CheckoutWizardCtrl(checkoutService, frameworkService, $localStorage, $state) {
            var vm = this;
            vm.$onInit = function () {
                vm.frameworkData = frameworkService.data;
                if (!vm.frameworkData.tenantFeatures.storefront) {
                    $state.go("main.notFound");
                    return;
                }
                if ($state.current.name === "main.checkout") {
                    $state.go("main.checkout.step1", {}, { location: "replace" });
                    return;
                }
                checkoutService.start();
                vm.wizard = checkoutService.wizard;
            };
            //$timeout(function () {
            //	if ($state.current.name === "main.checkout")
            //		$state.go("main.checkout.step1", {}, { location: "replace" });
            //});
            //$scope.$on("$viewContentLoaded", function () {
            //	if ($state.current.name === "main.checkout")
            //		$state.go("main.checkout.step1", {}, { location: "replace" });
            //});
        }
    });
}());
